const getSeenFieldDropChildren = () => {
  try {
    const seen = localStorage.getItem("seenFieldDropChildren");
    return Array.isArray(JSON.parse(seen)) ? JSON.parse(seen) : [];
  } catch (e) {
    return [];
  }
};

const addSeenFieldDropChildren = (newChildIds) => {
  const seen = getSeenFieldDropChildren();
  const updated = Array.from(new Set([...seen, ...newChildIds]));
  localStorage.setItem("seenFieldDropChildren", JSON.stringify(updated));
};

const useSeenFieldDropChildren = () => {
  return { getSeenFieldDropChildren, addSeenFieldDropChildren };
};

export default useSeenFieldDropChildren;
